module.exports = __webpack_public_path__ + "static/media/flatbread-product-1.cdcd5e9c.svg";